import { render, staticRenderFns } from "./CCalendarLocationPanel.vue?vue&type=template&id=33793f30&scoped=true"
import script from "./CCalendarLocationPanel.vue?vue&type=script&lang=ts"
export * from "./CCalendarLocationPanel.vue?vue&type=script&lang=ts"
import style0 from "./CCalendarLocationPanel.vue?vue&type=style&index=0&id=33793f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33793f30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
